export default "__VITE_ASSET__BszKX$s7__"